import { apiClient } from "@/libs/http";

import type { UserRole, UserDetails } from "@/types";

export type { UserRole, UserDetails };

export const me = async (): Promise<UserDetails> => {
  return await apiClient.get("/iam/v1/users/me");
};
